import request from '@/router/axios';
export const getCustomerOptions = (params) => {
    return request({
        url: '/api/produce/blade-dept/select/distinct/select',
        method: 'get',
        params
    })
}
export const add = (row) => {
    return request({
        url: '/api/produce/arrival-notice/dispatchInsert',
        method: 'post',
        data: row
    })
}
export const update = (row) => {
    return request({
        url: '/api/produce/arrival-notice/dispatchUpdate',
        method: 'post',
        data: row
    })
}
export const getDetail = (id) => {
    return request({
        url: '/api/produce/arrival-notice/operation-detail',
        method: 'get',
        params: {
            id
        }
    })
}
export const getList = (params) => {
    return request({
        url: '/api/produce/arrival-notice/select/page',
        method: 'get',
        params
    })
}
export const exportExcel = (params) => {
    return request({
        url: '/api/produce/arrival-notice/dispatch/export',
        method: 'get',
        params,
        responseType: 'blob'
    })
}
export const downloadImportTemplate = () => {
    return request({
        url: '/api/produce/arrival-notice/import-template',
        method: 'get',
        responseType: 'blob'
    })
}
export const remove = (ids) => {
    return request({
        url: '/api/produce/arrival-notice/delete/ids',
        method: 'get',
        params: {
            ids
        }
    })
}
export const importExcel = (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return request({
        url: '/api/produce/arrival-notice/import-excel',
        method: 'post',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

export const uploadRailwayTicket = (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return request({
        url: '/api/blade-resource/oss/endpoint/put-file-attach',
        method: 'post',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

export const importCarriageFile = (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return request({
        url: '/api/produce/arrival-notice/dispatch/import-carriage-file',
        method: 'post',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

export const importMineExcelPreview = (file, currentRows) => {
    const formData = new FormData();
    formData.append('file', file);
    if (currentRows) {
        formData.append('currentRows', currentRows);
    }
    return request({
        url: '/api/product-applet/arrivalNotice/importMineExcelPreview',
        method: 'post',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

export const matchMineExcel = (file, mapping, currentRows) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('mapping', JSON.stringify(mapping || {}));
    if (currentRows) {
        formData.append('currentRows', currentRows);
    }
    return request({
        url: '/api/product-applet/arrivalNotice/matchMineExcel',
        method: 'post',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

export const getDumpSupportedDict = () => {
    return request({
        url: '/api/blade-system/dict-biz/dictionary',
        method: 'get',
        params: {
            code: 'railway_dump_supported_vehicle_type'
        }
    })
}

export const getContractLocations = (row) => {
    return request({
        url: '/api/produce/arrival-notice/dispatch/contract-locations',
        method: 'post',
        data: row
    })
}

export const sendRailwayArrival = (id) => {
    return request({
        url: '/api/produce/arrival-notice/send-railway-arrival',
        method: 'post',
        params: {
            id
        }
    })
}

export const rollbackRailwayArrival = (id) => {
    return request({
        url: '/api/produce/arrival-notice/rollback-railway-arrival',
        method: 'post',
        params: {
            id
        }
    })
}

export const getRailwayArrivalSendLock = () => {
    return request({
        url: '/api/produce/arrival-notice/send-lock',
        method: 'get'
    })
}

export const audit = (id) => {
    return request({
        url: '/api/produce/arrival-notice/audit',
        method: 'get',
        params: { id }
    })
}

export const auditReject = (row) => {
    return request({
        url: '/api/produce/arrival-notice/audit-reject',
        method: 'post',
        data: row
    })
}

export const unAudit = (id) => {
    return request({
        url: '/api/produce/arrival-notice/unAudit',
        method: 'get',
        params: { id }
    })
}
